import * as React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {useNavigate} from "react-router";
import {useSelector} from "../../../redux/store";
import hasPermission from "../../../redux/hasPermission";
import {styled} from "@mui/material";


function AppBar() {
    const user_id = useSelector(state => state.auth.user_id);
    const sabitler = useSelector(state => state.app.sabitler);
    const user = sabitler?.kisiler?.find(k => k.id === user_id);
    const rumuz = user?.rumuz || "G";
    const userColor = user?.renk || "secondary.main";
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate();

    const gunsonuYetki = hasPermission("galleon_logbook.gunsonu")
    const yonetimYetki = hasPermission("galleon_logbook.yonetim")

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const pages = [
        {
            title: 'Takvim',
            link: '/Logbook/takvim',
            alwaysDisplay: true
        },
        {
            title: 'Günsonu',
            link: '/Logbook/gunsonu',
            alwaysDisplay: gunsonuYetki
        },
        {
            title: 'Yönetim',
            link: '/Logbook/yonetim',
            alwaysDisplay: yonetimYetki
        },
        {
            title: 'Menü Yönetimi',
            link: '/Logbook/menu-yonetimi',
            alwaysDisplay: yonetimYetki
        },
    ];
    const settings = [
        {
            title: 'Profil',
            link: '/Logbook/profil'
        },
        {
            title: 'Çıkış Yap',
            link: '/Logbook/logout'
        }
    ];

    const Img = styled('img')(() => ({
        height: 90,
        width: 90,
    }));

    return (
        <MuiAppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Img
                        alt="Galleon"
                        src="/images/logo/galleon_logo_512.png"
                        sx={{display: {xs: 'none', md: 'flex'}, mr: 1}}
                    />
                    <Box
                        component="a"
                        href="/Logbook"
                    >
                        <Typography
                            variant="h6"
                            noWrap

                            sx={{
                                mr: 2,
                                display: {xs: 'none', md: 'flex'},
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'white',
                                textDecoration: 'none',
                            }}
                        >
                            GALLEON
                        </Typography>
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                mr: 2,
                                display: {xs: 'none', md: 'flex'},
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'white',
                                textDecoration: 'none',
                            }}
                        >
                            LOGBOOK
                        </Typography>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{display: {xs: 'block', md: 'none'}}}
                        >
                            {pages.map((page) => (
                                page.alwaysDisplay &&
                                <MenuItem
                                    key={page.title}
                                    href={page.link}
                                    onClick={() => {
                                        navigate(page.link);
                                        handleCloseNavMenu();
                                    }}
                                    sx={{margin: ".3rem"}}
                                >
                                    <Typography sx={{textAlign: 'center'}}>{page.title}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <AdbIcon sx={{display: {xs: 'flex', md: 'none'}, mr: 1}}/>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="/Logbook"
                        sx={{
                            mr: 2,
                            display: {xs: 'flex', md: 'none'},
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        LOGBOOK
                    </Typography>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        {pages.map((page) => (
                            page.alwaysDisplay &&
                            <Button
                                key={page.title}
                                href={page.link}
                                onClick={() => {
                                    handleCloseNavMenu();
                                }}
                                sx={{margin: ".3rem", color: 'white', display: 'block'}}
                            >
                                {page.title}
                            </Button>
                        ))}
                    </Box>
                    <Box sx={{flexGrow: 0}}>
                        <Tooltip title="Open settings">
                            <IconButton onClick={handleOpenUserMenu} sx={{p: 0, width: "4rem", height: "4rem"}}>
                                <Avatar sx={{
                                    width: "4rem",
                                    height: "4rem",
                                    bgcolor: userColor,
                                    fontSize: rumuz.length > 3 ? `${4 / (rumuz.length * 0.9)}rem` : "1.5rem",
                                    lineHeight: 1,
                                }}>
                                    {rumuz}
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting.title} onClick={() => {
                                    navigate(setting.link);
                                    handleCloseUserMenu();
                                }} sx={{py: 1.5, px: 3, minWidth: '150px'}}>
                                    <Typography sx={{textAlign: 'center', fontSize: '0.80rem', fontWeight: 600}}>
                                        {setting.title}
                                    </Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </MuiAppBar>
    );
}

export default AppBar;